import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { Text } from '@fragments';
import './styles.scss';

const STEPS = ['onboardingAnalyzing1', 'onboardingAnalyzing2', 'onboardingAnalyzing3'];

// What the analysis is doing, one line at a time while the profile is read.
export default function AnalyzingTicker({ t }) {
  const reduced = useReducedMotion();
  const [index, setIndex] = useState(0);
  useEffect(() => {
    if (reduced) return undefined;
    const timer = setInterval(() => setIndex(step => (step + 1) % STEPS.length), 2400);
    return () => clearInterval(timer);
  }, [reduced]);
  return <span className="studio-analyzing">
    <span className="studio-visually-hidden">{t('onboardingAnalyzingHeading')}</span>
    <AnimatePresence initial={false} mode="popLayout">
      <motion.span key={index} className="studio-analyzing__line studio-ai-heading" aria-hidden="true"
        initial={{ y: '100%', opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: '-100%', opacity: 0 }} transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}>
        <Text.p>{t(STEPS[index])}</Text.p>
      </motion.span>
    </AnimatePresence>
  </span>;
}
